// extracted by mini-css-extract-plugin
export var blogTitle = "blog-post-module--blogTitle--c9bef";
export var date = "blog-post-module--date--bf4b2";
export var featuredImage = "blog-post-module--featuredImage--f71b1";
export var tagItem = "blog-post-module--tagItem--062b9";